import { useFormContext } from "react-hook-form";
import { FormField } from "@babackapp/ui/components/form";
import { ShopImportFormValues } from "./import-settings-form-types";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";

export default function ImportOptionsForm() {
  return (
    <div className="flex flex-col gap-8">
      <DelimiterInput />
      <WithHeaderSwitch />
      <FileToImportFilterRegexInput />
    </div>
  );
}

function DelimiterInput() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.delimiter"
      control={control}
      render={({ field }) => (
        <FormInput
          label="Delimiter"
          description="Delimiter used in the file"
          {...field}
        />
      )}
    />
  );
}

function WithHeaderSwitch() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.withHeader"
      control={control}
      render={({ field }) => (
        <FormSwitch
          label="With Header"
          description="Whether the file has a header row"
          {...field}
        />
      )}
    />
  );
}

function FileToImportFilterRegexInput() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.fileToImportFilterRegex"
      control={control}
      render={({ field }) => (
        <FormInput
          label="File to Import Filter Regex"
          description="Regex to filter files to import"
          {...field}
        />
      )}
    />
  );
}
